import Icon from '../../components/Icon.vue'

Icon.register({
  'regular/kiss-wink-heart': {
    width: 504,
    height: 512,
    paths: [
      {
        d: 'M304 308.5C304 289.3 275.2 267 232.5 264.5 228.7 264.1 225.1 266.9 224.3 270.7 223.4 274.5 225.4 278.4 229 279.9L245.9 287.1C258.9 292.6 266.7 300.6 266.7 308.6S258.9 324.6 246 330.1L229 337.3C223.3 339.7 223 349.5 229 352.1L245.9 359.3C258.9 364.8 266.7 372.8 266.7 380.8S258.9 396.8 246 402.3L229 409.5C225.4 411 223.4 414.9 224.3 418.7 225.1 422.3 228.4 424.9 232.1 424.9H232.6C275.4 422.4 304.1 400.1 304.1 380.9 304.1 367.9 290.7 353.6 268.9 344.9 290.6 335.8 304 321.5 304 308.5zM374.5 225L384 233.5C387.8 236.8 393.3 237.5 397.7 235.1 402.1 232.7 404.6 227.7 403.8 222.7 399.8 197.5 369.6 180.6 344 180.6S288.1 197.5 284.2 222.7C283.4 227.7 285.9 232.7 290.3 235.1 296.1 238.2 301.5 235.8 304 233.5L313.5 225C328.3 211.8 359.7 211.8 374.5 225zM136 208.5C136 226.2 150.3 240.5 168 240.5S200 226.2 200 208.5 185.7 176.5 168 176.5 136 190.8 136 208.5zM501.1 402.5C493.1 381.7 469.6 371 448 376.6L439.6 378.8 437.3 370.4C431.4 349 410.3 333.9 388.3 337.4 363.1 341.4 347.7 366 354.3 390L377.2 472.6C378.7 477.9 384.2 481.1 389.6 479.7L472.6 458.2C496.7 451.9 510.3 426.4 501.1 402.5zM334 436.3C307.9 448.8 278.8 456 248 456 137.7 456 48 366.3 48 256S137.7 56 248 56 448 145.7 448 256C448 278.1 444.3 299.3 437.6 319.2 446.6 325.6 454.6 333.4 460.2 343.1 466.6 343.2 472.8 344.5 478.8 346 489.7 318.1 495.9 287.8 495.9 256 496 119 385 8 248 8S0 119 0 256 111 504 248 504C283.4 504 316.9 496.5 347.4 483.1 344.9 475.8 351.7 500.3 334 436.3z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/regular/kiss-wink-heart.js
// module id = qk/A
// module chunks = 144